import type { FaireProductEntity } from "../../entity_types/product";

export const p_798q6x48kj: FaireProductEntity = {
  token: "p_798q6x48kj",
  type: "product",
  name: "Horse - Organic Cotton Jacquard Sweater Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/405818ca526b08c306b90bcf7ca6dcdbe64a67741fb1a694b36127994f0fc7b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07fa0b41dfbfe36cac9974ef6a56d9030a12cdbff781e583a5283646dea066c2.jpeg",
    "https://cdn.faire.com/fastly/48b7c52dd0ee34bd7663b0ab8352a9be81330db86ccde860e72708f9fb56aef5.jpeg",
    "https://cdn.faire.com/fastly/1035909790789751631013508e0c61fed8f2213794ee8e3706a1a4e418e62fa2.jpeg",
    "https://cdn.faire.com/fastly/0eca4ad0173ef7f9d24a44de15a2de4de01861d41fb33a7b923d74ea58828633.jpeg",
    "https://cdn.faire.com/fastly/3d9c7e5d2f32a62cca3b15fd8eef5ef63300b2db80ae473f59f5efe8505cca07.jpeg",
    "https://cdn.faire.com/fastly/dde34b74763531921443e42ebc358ac9e1cef48291686b2e189414f1ed93412b.jpeg",
    "https://cdn.faire.com/fastly/388849a8abc43069a44b5667a46712c1609646fa5241858009c008753ecb5a47.jpeg",
    "https://cdn.faire.com/fastly/2a480e9bd282771f0f4a86c28b280ba0459c6aeb0e06a7a03f4ac8f50051904d.jpeg",
  ],
  priceDollars: 26,
  description:
    "Gallop into cozy with this Organic Cotton Jacquard Sweater Knit Baby Blanket, thoughtfully crafted for sweet dreams and everyday cuddles. Featuring an adorable horse motif, it brings a touch of whimsy while staying timeless and calm.\n\nMade from 100% organic cotton, this blanket is ultra-soft, lightweight, and breathable—comfortable enough for all seasons and gentle on delicate skin.\n\n• Large size: 30 × 42 inches\n• Ultra-soft, lightweight, breathable, cozy, and comfortable\n• Made from non-toxic, natural fibers, ideal for sensitive skin\n• Crafted using eco-friendly, sustainable materials\n• Made from sustainably grown organic cotton, supporting better livelihoods for small grower farmers\n• Thoughtfully designed in the USA and ethically made in India by skilled artisans\n\nCreated with care by Viverano, a family-owned small business dedicated to pure, honest comfort—because the coziest things are made the right way.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:32.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
